import React from 'react';
import { CheckCircle2, Phone } from 'lucide-react';
const PHONE = '586-203-3701';
export function ShingleFocus() {
  return <section className="bg-white py-20 sm:py-24" data-id="element-216">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-218">
          {/* Image */}
          <div className="relative" data-id="element-219">
            <img src="https://images.unsplash.com/photo-1605152276897-4f618f831968?w=1200&q=80&auto=format&fit=crop" alt="Close-up of new architectural asphalt shingles installed on a Michigan home" className="w-full h-[420px] sm:h-[520px] object-cover rounded-2xl shadow-xl" onError={e => {
            ;
            (e.currentTarget as HTMLImageElement).src = 'https://images.unsplash.com/photo-1632759145355-c1f3c91d7b5d?w=1200&q=80&auto=format&fit=crop';
          }} data-id="element-220" />
            <div className="absolute -bottom-6 -right-6 hidden md:flex flex-col bg-[#2DB8E0] text-white px-6 py-4 rounded-xl shadow-lg" data-id="element-221">
              <span className="font-display italic text-3xl leading-none" data-id="element-222">
                25+
              </span>
              <span className="text-sm font-semibold uppercase tracking-wide mt-1" data-id="element-223">
                Years roofing
                <br data-id="element-224" />
                Michigan homes
              </span>
            </div>
          </div>

          {/* Copy */}
          <div data-id="element-225">
            <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-226">
              Shingle Roof Replacement
            </span>
            <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-6" data-id="element-227">
              Built for Michigan. Backed by Quality.
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-228">
              Michigan winters are brutal on shingle roofs. Ice dams,
              freeze-thaw cycles, and heavy snow loads can take years off a
              poorly-installed roof. We use premium architectural shingles rated
              for Michigan's extreme weather — installed by a crew that's been
              doing this for decades.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-229">
              {['Complete tear-off of old roofing materials', 'Decking inspection & repair where needed', 'Premium ice & water shield protection', 'Architectural shingles — 25 to 50 year lifetime warranties', 'Proper ventilation & ridge cap installation', 'Full cleanup with magnetic nail sweep'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-230">
                  <CheckCircle2 className="w-6 h-6 text-[#2DB8E0] flex-shrink-0 mt-0.5" data-id="element-231" />
                  <span className="text-slate-700 font-medium" data-id="element-232">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-233">
              <a href="#quote-form" className="inline-flex items-center justify-center bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-7 py-4 rounded-full transition-all shadow-md hover:shadow-lg" data-id="element-234">
                <span className="mr-2" data-id="element-235">—</span>
                Get a Quote Now!
                <span className="ml-2" data-id="element-236">—</span>
              </a>
              <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white font-bold px-6 py-4 rounded-full transition-colors" data-id="element-237">
                <Phone className="w-5 h-5" data-id="element-238" /> {PHONE}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}